const formatSpecialist = (specialty: string) => {
  switch (specialty) {
    case 'General Practitioner':
      return 'GP';
    default:
      return specialty;
  }
};

export const formatSubheading = (specialties: string[], gender?: string | null) => {
  const specs = (specialties || []).map(formatSpecialist).join(', ');
  return [specs, gender].filter(value => !!value).join(' - ');
};
